
export default [
  {
    "ref": "juna-team",
    "name": "Juna Team",
    "avatar": "https://meetjuna.com/junologo.png",
    "content": "",
    "_meta": {
      "filePath": "authors/juna-team.mdx",
      "fileName": "juna-team.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/juna-team"
    }
  }
]